import { ColumnTypes } from '@/components';
import { cn } from '@/utils';

export const getColumns = (): ColumnTypes => [
	{
		title: `ID`,
		dataIndex: 'assignmentFranchiseId',
		key: 'assignmentFranchiseId',
		align: 'center',
		render: (value: string) => (
			<>
				<div
					className={cn(
						'text-blue2 underline cursor-pointer',
						value ? 'font-bold' : ''
					)}
				>
					{value}
				</div>
			</>
		),
	},
	{
		title: '고용주',
		dataIndex: 'franchiseEmployerName',
		key: 'franchiseEmployerName',
		align: 'center',
	},
	{
		title: '사업장 주소',
		dataIndex: 'franchiseAddress',
		key: 'franchiseAddress',
		align: 'center',
	},
	{
		title: '근로자',
		dataIndex: 'applicantFullName',
		key: 'applicantFullName',
		align: 'center',
	},
	{
		title: '근로자 생년월일',
		dataIndex: 'applicantBirthDate',
		key: 'applicantBirthDate',
		align: 'center',
	},
	{
		title: '배정기간',
		dataIndex: 'assignmentFranchiseStartEndDate',
		key: 'assignmentFranchiseStartEndDate',
		align: 'center',
		width: 250,
	},
	{
		title: '등록일',
		dataIndex: 'registDt',
		key: 'registDt',
		align: 'center',
	},
];

export const SearchType = {
	EMPLOYER_NAME: 'EMPLOYER_NAME',
	FRANCHISE_ADDRESS: 'FRANCHISE_ADDRESS',
	APPLICANT_NAME: 'APPLICANT_NAME',
};

export const TYPE_SEARCH_FRANCHISE_OPTIONS = [
	{
		value: SearchType.EMPLOYER_NAME,
		label: '고용주',
	},
	{
		value: SearchType.FRANCHISE_ADDRESS,
		label: '사업장 주소',
	},
	{
		value: SearchType.APPLICANT_NAME,
		label: '근로자',
	},
];

export const TYPE_SEARCH_FRANCHISE_OPTIONS_BM1_03 = [
	{
		value: SearchType.APPLICANT_NAME,
		label: '근로자',
	},
];
